import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { trainingApi } from "../../services";
import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import { skillService } from "../../services/profile";
import { toast } from "react-toastify";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { projectStatusOfResource } from '../../common/util/constants';

const CreateEmpTrfForm = ({ setScreen, reload }) => {
  const loggedInUser = useSelector(selectUser);
  const [trainingCategory, setTrainingCategory] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [addSkillDialog, setAddSkillDialog] = useState(false);
  const [newSkillTitle, setNewSkillTitle] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const [currentProject, setCurrentProject] = useState([]);
  const [reqTrainingPurpose, setReqTrainingPurpose] = useState([]);
  const [outComeTrainingPurpose, setOutComeTrainingPurpose] = useState([]);
  const [currentstatus, setCurrentstatus] = useState([]);
  const [skillLevel, setSkillLevel] = useState([]);
  const [rowClick, setRowClick] = useState(true);
  const [selectedSkillLevel, setSelectedSkillLevel] = useState(null);
  const [skillLevelStatus, setSkillLevelStatus] = useState(false);
  const [reqTrainingStatus, setReqTrainingStatus] = useState(false);
  const [outComeStatus, setOutComeStatus] = useState(false);

  useEffect(() => {
    const mockSkillsLevel = [
      {
        id: 1,
        skills: <b>Current skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
      {
        id: 2,
        skills: <b>Expected skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
    ];
    setSkillLevel(mockSkillsLevel);
    fetchSkillsList();
    fetchEngagement();
    fetchCategories();
    fetchRequestedTraining();
    getUserDetails();
  }, []);


  const fetchSkillsList = () => {
    skillService.getSkills().then((resp) => {
      setSkillList(resp.data.data);
    });
  };

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      setCurrentstatus(resp.data.data);
    });
  };

  const fetchRequestedTraining = () => {
    let purposeReqTrainingData;
    let businessOutcomeTrainingData;
    trainingApi.getRequestedTraining().then((resp) => {
      purposeReqTrainingData = resp?.data?.data?.filter(item => item.type === 0);
      businessOutcomeTrainingData = resp?.data?.data?.filter(item => item.type === 1);

      setReqTrainingPurpose(purposeReqTrainingData);
      setOutComeTrainingPurpose(businessOutcomeTrainingData);
    });
  };

  const fetchCategories = () => {
    trainingApi.fetchTrainingCategoryList().then((resp) => {
      setTrainingCategory(resp.data.data);
    });
  };

  const getUserDetails = () => {
    trainingApi.getUserDetailsById(loggedInUser?.id).then((resp) => {
      const userData = [resp?.data?.data];
      const transformedData = userData.map((user) => {
        return {
          ...user,
          name: `${user.firstName} ${user.lastName}`.trim(),
        }
      });
      formik.setFieldValue("nominatedParticipant", transformedData[0]);
      const result = userData[0].Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
      setCurrentProject(result);
      if (userData[0].Allocations?.length > 0) {
        const firstBillableItem = userData[0].Allocations.find(item => item.isBillable === true);
        if (firstBillableItem) {
          const filteredBillableStatus = result.filter(item => item.isBillable === true);
          formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
          formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
        } else {
          formik.setFieldValue("resourceCurrentProject", result[0]?.title);
          formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
        }
      } else {
        setCurrentProject([]);
      }
      setEmployeeList(transformedData);
    });
  }


  const handleAddNewSkill = async () => {
    const title = newSkillTitle.trim();
    if (!title) return;
    try {
      const res = await skillService.findOrCreateSkill(title);
      const skill = res.data?.data;
      if (!skillList.some(s => s.id === skill.id)) {
        setSkillList(prev => [...prev, skill]);
      }
      formik.setFieldValue('targetSkill', skill);
      setNewSkillTitle('');
      setAddSkillDialog(false);
      toast.success('Skill added successfully');
    } catch {
      toast.error('Failed to add skill');
    }
  };
  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const fetchLevelValue = (index) => {
    const getKeyByValue = (obj, value) => {
      return Object.keys(obj).find(key => obj[key] === value);
    };
    const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
    return fetchLevelValName(keyWithTrueValue);
  };

  const fetchValue = (index) => {
    const getKeyByValue = (obj, value) => {
      return Object.keys(obj).find(key => obj[key] === value);
    };
    const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
    return fetchLevelNumber(keyWithTrueValue);
  };

  const fetchLevelNumber = (levelName) => {
    const levelMapping = {
      "beginnerNoKnowledge": 1,
      "beginnerBasicKnowledge": 2,
      "intermediateGoodKnowledge": 3,
      "intermediateStrongExperience": 4,
      "expert": 5
    };
    return levelMapping[levelName] || null;
  };

  const fetchLevelValName = (levelName) => {
    const levelMapping = {
      "beginnerNoKnowledge": 'Beginner Level',
      "beginnerBasicKnowledge": 'Basic Level',
      "intermediateGoodKnowledge": 'Intermediate Level',
      "intermediateStrongExperience": 'Strong Level',
      "expert": 'Expert Level'
    };
    return levelMapping[levelName] || null;
  };

  const trainingType = [
    { name: "Self-Paced", value: "Self-Paced" },
    { name: "Instructor-Led", value: "Instructor-Led" },
  ];

  const formik = useFormik({
    initialValues: {
      requesterName: loggedInUser?.superior?.firstName + " " + loggedInUser?.superior?.lastName,
      requesterEcn: loggedInUser?.ecn,
      requesterBu: "BU-" + loggedInUser?.businessUnitId,
      requisitionDate: new Date(),
      trainingCategory: null,
      // trainingType: null,
      targetSkill: null,
      // nominatedParticipant: null,
      resourceCurrentProject: null,
      resourceProjectStatus: null,
      resourceCurrentTech: "",
      // trainingEndDate: "",
      // improvmentAreaComment: "",
      // moduleDetails: "",
      // skillsetLevel: "",
      // reqTrainingPurpose: []
    },
    validate: (data) => {
      let errors = {};
      // const isValid = skillLevel.every(item =>
      //   Object.values(item).some(value => value === true)
      // );
      // if (!isValid) {
      //   setSkillLevelStatus(true);
      // }
      // let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      // let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      // if (requestedTrainingList.length === 0) {
      //   setReqTrainingStatus(true);
      // }
      // if (outComeTrainingList.length === 0) {
      //   setOutComeStatus(true);
      // }
      // if (!data.trainingType) errors.trainingType = "Type is required";
      if (!data.trainingCategory) errors.trainingCategory = "Category is required";
      if (!data.targetSkill) errors.targetSkill = 'Target Skill is required.';
      // if (!data.nominatedParticipant) errors.nominatedParticipant = 'Participant Name is required.';
      if (!data.resourceCurrentProject) errors.resourceCurrentProject = 'Project is required.';
      if (!data.resourceProjectStatus) errors.resourceProjectStatus = 'Resource Status is required.';
      if (!data.resourceCurrentTech) errors.resourceCurrentTech = 'Current Tech. is required.';
      // if (!data.trainingEndDate) errors.trainingEndDate = 'End Date is required.';
      // if (!data.improvmentAreaComment) errors.improvmentAreaComment = 'Triggering Area is required.';
      // if (!data.moduleDetails) errors.moduleDetails = 'Details is required.';

      return errors;
    },
    onSubmit: (data) => {
      // let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      // let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      let trfPayload = {
        "userId": loggedInUser?.id,
        "nameOfRequester": data?.requesterName,
        "ecnOfRequester": data?.requesterEcn,
        "businessUnit": data?.requesterBu,
        "trainingRequisitionDate": moment(data?.requisitionDate).format("YYYY-MM-DD"),
        // "trainingType": data?.trainingType,
        "categoryOfTraining": data?.trainingCategory,
        "targetSkill": data?.targetSkill?.id,
        "targetSkillName": data?.targetSkill?.title,
        "nameOfNominatedParticipant": data?.nominatedParticipant?.name,
        "currentStatusOfNominatedResource": data?.resourceProjectStatus === "Billable" ? 1 : 2,
        "projectName": data?.resourceCurrentProject,
        "currentTechnology": data?.resourceCurrentTech,
        // "endDateOfTraining": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
        // "improvementAreaTriggeringTrainingNeed": data?.improvmentAreaComment,
        // "moduleSpecificDetails": data?.moduleDetails,
        // "currentLevel": fetchValue(0),
        // "expectedLevel": fetchValue(1),
        // "currentLevelValue": fetchLevelValue(0),
        // "expectedLevelValue": fetchLevelValue(1),
        // "purposeOfRequestedTraining": requestedTrainingList,
        // "businessoutcome": outComeTrainingList,
      }
      if (!skillLevelStatus && !reqTrainingStatus && !outComeStatus) {
        CreateUserTrfFormm(trfPayload);
      }
    },
  });

  const CreateUserTrfFormm = (params) => {
    try {
      trainingApi.createTRFform(params).then(
        (resp) => {
          toast.success(resp.data.message);
          if (resp?.data?.data?.trainingRequisition?.id) {
            setTimeout(() => {
              setScreen('historyList');
              reload();
            }, 1000);
          }
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  }

  const handleDateChange = (date) => {
    formik.setFieldValue("requisitionDate", date);
    formik.setFieldValue("trainingEndDate", "");
  };

  // const handleTrainingDateChange = (date) => {
  //   formik.setFieldValue("trainingEndDate", date);
  // }


  /* Skill Level Template Start */
  const radioTemplate = (skillLevelRadio) => (rowData) =>
  (
    <RadioButton
      inputId={`${rowData.id}-${skillLevelRadio}`}
      checked={rowData[skillLevelRadio]}
      onChange={() => handleRadioSelection(rowData.id, skillLevelRadio)}
    />
  );

  const handleRadioSelection = (productId, skillLevelRadio) => {
    const updatedProducts = skillLevel.map((product) => {
      if (product.id === productId) {
        return {
          ...product,
          beginnerNoKnowledge: skillLevelRadio === "beginnerNoKnowledge",
          beginnerBasicKnowledge: skillLevelRadio === "beginnerBasicKnowledge",
          intermediateGoodKnowledge: skillLevelRadio === "intermediateGoodKnowledge",
          intermediateStrongExperience:
            skillLevelRadio === "intermediateStrongExperience",
          expert: skillLevelRadio === "expert",
        };
      }
      return product;
    });
    const isValid = updatedProducts.every(item =>
      Object.values(item).some(value => value === true)
    );
    if (isValid) {
      setSkillLevelStatus(false);
    }
    setSkillLevel(updatedProducts);
  };
  /* Skill Level Template Start */

  // const handleCheckboxChangeforPurpose = (e, item) => {
  //   const updatedData = reqTrainingPurpose.map(i =>
  //     i.id === item.id ? { ...i, isChecked: e.checked } : i
  //   );
  //   setReqTrainingStatus(false);
  //   setReqTrainingPurpose(updatedData);
  // };

  // const handleCheckboxChangeforBussiness = (e, item) => {
  //   const updatedData = outComeTrainingPurpose.map(i =>
  //     i.id === item.id ? { ...i, isChecked: e.checked } : i
  //   );
  //   setOutComeStatus(false);
  //   setOutComeTrainingPurpose(updatedData);
  // };

  return (
    <div className="card">
      <form onSubmit={formik.handleSubmit} autoComplete='off'>
        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-12 sm:col-4 md:col-3">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Category Of Training</label>
            <Dropdown name="trainingCategory" value={formik.values.trainingCategory} onChange={(e) => formik.handleChange(e)} options={trainingCategory} optionLabel="title" optionValue="id" placeholder="Select a Category" className="w-full" />
            {getFormErrorMessage('trainingCategory')}
          </div>
          <div className="col-12 sm:col-4 md:col-3">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Target Skill</label>
            <div className="flex align-items-center gap-2">
              <Dropdown
                name="targetSkill"
                value={formik.values.targetSkill}
                onChange={(e) => formik.setFieldValue('targetSkill', e.value)}
                options={skillList}
                optionLabel="title"
                placeholder="Select Target Skill"
                // className="w-full"
                style={{width:'220px'}}
                filter
              />
              <Button
                type="button"
                icon="pi pi-plus"
                label="Add New Skill"
                className="p-button-text p-button-sm white-space-nowrap"
                onClick={() => { setNewSkillTitle(''); setAddSkillDialog(true); }}
              />
            </div>
            {getFormErrorMessage('targetSkill')}
          </div>

          <Dialog
            header="Add New Skill"
            visible={addSkillDialog}
            style={{ width: '350px' }}
            onHide={() => setAddSkillDialog(false)}
            footer={
              <div>
                <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setAddSkillDialog(false)} />
                <Button label="Save" icon="pi pi-check" onClick={handleAddNewSkill} disabled={!newSkillTitle.trim()} />
              </div>
            }
          >
            <div className="p-fluid">
              <label className="font-bold block mb-2">Skill Name</label>
              <InputText
                value={newSkillTitle}
                onChange={(e) => setNewSkillTitle(e.target.value)}
                placeholder="Enter skill name"
                onKeyDown={(e) => e.key === 'Enter' && handleAddNewSkill()}
                autoFocus
              />
            </div>
          </Dialog>
          <div className="col-12 sm:col-4 md:col-3">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Project Details</label>
            <Dropdown name="resourceCurrentProject" value={formik.values.resourceCurrentProject} onChange={(e) => formik.handleChange(e)} options={currentProject} optionLabel="title" optionValue="title" placeholder="Select Project" className="w-full" />
            {getFormErrorMessage('resourceCurrentProject')}
          </div>
          <div className="col-12 sm:col-4 md:col-3">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Current Status Of Nominated Resource</label>
            <Dropdown name="resourceProjectStatus" value={formik.values.resourceProjectStatus} onChange={(e) => formik.handleChange(e)} options={projectStatusOfResource} optionValue="title" optionLabel="title" placeholder="Select Status" className="w-full" />
            {getFormErrorMessage('resourceProjectStatus')}
          </div>


          <div className="col-12 sm:col-4 md:col-3">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Current Technology</label>
            <InputText name="resourceCurrentTech" value={formik.values.resourceCurrentTech} onChange={(e) => formik.handleChange(e)} placeholder="Enter Current Technology" className="w-full" style={{ background: "#fff" }} />
            {getFormErrorMessage('resourceCurrentTech')}
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block mt-4">
          <div className="col-12 flex">
            <Button type="submit" label="Submit" />
          </div>
        </div>
      </form>

    </div>
  )
}

export default CreateEmpTrfForm;
